import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

import Actions from './Actions';
import {
  getMessage,
  getStatus,
  getLocalFormattedTime,
  getLastComment
} from './utils';

const Row = ({ order, fetchOrders, header }) => {
  const { groupId, groupRecords } = order;
  const [open, setOpen] = useState(false);
  const [sites, setSitesList] = useState([]);

  useEffect(() => {
    if (groupId) {
      const temp = [order].concat(groupRecords);
      temp.sort((a, b) => (a.currentSite > b.currentSite && 1) || -1);
      setSitesList(temp);
    }
  }, []);

  const getTagStyles = color => {
    return {
      background: color,
      color: 'white',
      textAlign: 'center',
      fontWeight: 'bold',
      padding: '2px',
      width: '60px',
      fontSize: '12px',
      borderRadius: '2px',
      margin: '0 auto'
    };
  };

  const getBgColor = isChildOrder => {
    if (isChildOrder) {
      return '#fff9ef';
    }
    return null;
  };

  const renderParentRow = () => {
    const { businessLegalName } = order;
    return (
      <tr
        style={{ background: getBgColor(), cursor: 'pointer' }}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <td>
          <div>
            {groupId}
            <div style={getTagStyles(`#4c2b6c`)}>Multi site</div>
          </div>
        </td>
        <td>{businessLegalName}</td>
        <td />
        <td />
        <td />
        <td />
        <td />
        <td
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          {open ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}{' '}
        </td>
      </tr>
    );
  };

  const renderChildRow = (data, isChildOrder) => {
    const {
      orderId,
      businessLegalName,
      typeOfInstallation,
      updatedAt,
      currentSite
    } = data;
    const { statusToolTip, statusId } = getStatus(data);
    return (
      <tr style={{ background: getBgColor(isChildOrder) }}>
        <td data-header-label={header[0]}>
          {orderId}
          {isChildOrder && (
            <div style={getTagStyles(`#6aca25`)}>{`Site: ${currentSite}`}</div>
          )}
        </td>
        <td data-header-label={header[1]}>{businessLegalName}</td>
        <td data-header-label={header[2]}>{typeOfInstallation}</td>
        <td data-header-label={header[3]}>
          {getLocalFormattedTime(updatedAt)}
        </td>
        <td data-header-label={header[4]}>{statusToolTip}</td>
        <td data-header-label={header[5]}>
          <div className="responsive-table__comment">
            {getLastComment(_.get(data, 'orderComments.0.text', ''))}
          </div>
        </td>
        <td data-header-label={header[6]}>{getMessage(data, fetchOrders)}</td>
        <td data-header-label={header[7]}>
          <Actions status={statusId} order={data} fetchOrders={fetchOrders} />
        </td>
      </tr>
    );
  };

  return (
    <>
      {groupId ? (
        <>
          {renderParentRow()}
          {open && (
            <>
              {sites && sites.length ? (
                sites.map(data => renderChildRow(data, true))
              ) : (
                <></>
              )}
            </>
          )}
        </>
      ) : (
        renderChildRow(order, false)
      )}
    </>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired,
  header: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Row;
